import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Hero from "../Components/Hero";
import welcomeImg from '../Images/welcome-img.webp'
import { welcomePoints, instaPosts } from "../Data";
import { blogs } from "../Blog";
import TreatmentGrid from "../Components/TreatmentGrid";
import Stats from "../Components/Stats";
import WhyChoose from "../Components/WhyChoose";
import drImg from '../Images/dr-jigar-gor.webp'
import Facilities from "../Components/Facilites";
import Youtube from "../Components/Youtube";
import Testimonials from "../Components/Testimonials";
import topRightDesign from '../Images/intro-top-right.png'
import bottomRightDesign from '../Images/intro-bottom-right.png'
import greenDesign from '../Images/green-design.svg'
import FooterTopDesign from "../Images/footer-design.svg";
import MedicalClinicSchema from "../Schema/MedicalClinicSchema";
import OrganizationSchema from "../Schema/OrganizationSchema";
import WebsiteSchema from "../Schema/WebsiteSchema";

const Home=()=>{
      useEffect(() => {
    document.title =
      "Best Ayurvedic Doctor in Bhuj Kutch | Dr. Jigar Gor";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Authentic Ayurvedic Treatment in Bhuj. Expert doctor for Panchkarma, GarbhSanskar, Bone & Joint Care, Skin, & Hair Care. Best Ayurvedic Clinic in Kutch."
      );
    }

  const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://msayurved.com/");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Best Ayurvedic Doctor in Bhuj Kutch | Dr. Jigar Gor"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Authentic Ayurvedic Treatment in Bhuj. Expert doctor for Panchkarma, GarbhSanskar, Bone & Joint Care, Skin, & Hair Care. Best Ayurvedic Clinic in Kutch."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://msayurved.com/");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://msayurved.com/Images/home.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Best Ayurvedic Doctor in Bhuj Kutch | Dr. Jigar Gor"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Authentic Ayurvedic Treatment in Bhuj. Expert doctor for Panchkarma, GarbhSanskar, Bone & Joint Care, Skin, & Hair Care. Best Ayurvedic Clinic in Kutch."
    );
  }

   const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://msayurved.com/Images/home.webp"
    );
  }
  }, []);

  const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.2,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -60,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1.4,
      ease: "easeOut",
    },
  },
};

const pointVariant = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: "easeOut",
    },
  },
};

const gridContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.2,
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};
    return(
        <>

        <MedicalClinicSchema />
  <OrganizationSchema />
  <WebsiteSchema />

        {/**HERO SECTION */}
        <Hero />

        {/**WELCOME SECTION */}
        <section className="welcome-section">
    <img
    src={topRightDesign}
    alt="Welcome to Dr. Jigar Gor’s Ayurveda"
    className="welcome-design welcome-design-top"
  />

  {/* BOTTOM RIGHT DESIGN */}
  <img
    src={bottomRightDesign}
    alt="Welcome to Dr. Jigar Gor’s Ayurveda"
    className="welcome-design welcome-design-bottom"
  />
  <motion.div
    className="welcome-img"
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.2,
    }}
    variants={fadeLeft}
  >

    <img
      src={welcomeImg}
      alt="Welcome to Dr. Jigar Gor’s Ayurveda"
    />
  </motion.div>

  <div className="container">
    <motion.div
      className="welcome-content"
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.2,
      }}
    >
      <motion.p
        className="section-subheading"
        variants={fadeUp}
      >
        Ancient Wisdom, Modern Healing
      </motion.p>

      <motion.h2
        className="section-heading"
        variants={fadeUp}
      >
        Welcome to Dr. Jigar Gor’s Ayurveda
      </motion.h2>

      <motion.p
        className="special-text"
        variants={fadeUp}
      >
        “ Where Ancient Ayurveda Heals You Completely ”
      </motion.p>

      <motion.p
        className="section-text"
        variants={fadeUp}
      >
        At Dr. Jigar Gor's Ayurveda Center, we
        seamlessly bridge the gap between time-tested Vedic
        tradition and modern lifestyle needs under the expert
        guidance of Dr. Jigar Gor. Moving far beyond temporary
        symptom relief, our specialized treatment center focuses
        entirely on healing the root cause of chronic illness by
        gently restoring your body’s natural, inherent balance.
        Through precise, scientific Prakruti Parikshan (Body Type
        Analysis), we accurately identify your individual Dosha
        (Vata, Pitta, Kapha) imbalances. This allows us to craft a
        deeply personalized, expert-guided wellness blueprint that
        eliminates the risks of harmful self-medication, safely
        unlocks sustainable vitality, and guides you toward
        long-term, holistic health.
      </motion.p>

      {welcomePoints.map((item, i) => (
        <motion.ul
          key={i}
          variants={pointVariant}
        >
          <li className="section-text">
            <strong>{item.title}</strong> {item.desc}
          </li>
        </motion.ul>
      ))}

      <motion.div
        className="hero-btns"
        variants={fadeUp}
      >
        <motion.a
          href="/about-us"
          className="primary-btn"
          whileHover={{
            scale: 1.04,
          }}
          transition={{
            duration: 0.4,
          }}
        >
          Know More About Us
        </motion.a>

        <motion.a
          href="/book-appointment"
          className="secondary-btn"
          whileHover={{
            scale: 1.04,
          }}
          transition={{
            duration: 0.4,
          }}
        >
          Book Appointment
        </motion.a>
      </motion.div>
    </motion.div>
  </div>
</section>

    {/**OUR TREATMENTS SECTION */}
    <TreatmentGrid />

    {/**STATS SECTION */}
    <Stats />

    {/**WHY CHOOSE US SECTION */}
    <WhyChoose />

    {/**ABOUT JIGAR GOR SECTION */}
   <section className="home-about-section container">
  <motion.div
    className="home-about-left"
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.2,
    }}
    variants={fadeLeft}
  >
    <motion.img
      src={drImg}
      alt="Dr. Jigar Gor"
      whileHover={{
        scale: 1.02,
      }}
      transition={{
        duration: 0.5,
      }}
    />
  </motion.div>

  <motion.div
    className="home-about-right"
    variants={staggerContainer}
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.2,
    }}
  >
    <motion.p
      className="section-subheading"
      variants={fadeUp}
    >
      About the Doctor
    </motion.p>

    <motion.div
      className="home-about-right-row"
      variants={fadeUp}
    >
      <div className="home-about-right-col">
        <h2 className="section-heading">
          About Dr. Jigar Gor
        </h2>

        <p className="special-text">
          [ BAMS, DYA, PGPP, PGDEMS ] - Ayurveda Consultant
        </p>
      </div>

     <motion.p
  className="sanskrit-text"
  initial={{
    opacity: 0,
  }}
  whileInView={{
    opacity: 1,
  }}
  viewport={{
    once: true,
  }}
  transition={{
    duration: 2,
    delay: 0.8,
  }}
>
        तस्मात् शास्त्रे अर्थ विज्ञाने प्रवृत्तौ कर्मदर्शने ।
        भिषक् चतुष्टये युक्तः प्राणाभिसर उच्यते ॥
        <br />
        - चरक संहिता
      </motion.p>
    </motion.div>

    <motion.p
      className="section-text"
      variants={fadeUp}
    >
      In the timeless scriptures of Ayurveda, a physician who
      is deeply dedicated to studying the medical sciences,
      mastering their practical applications, and executing
      therapies with extensive hands-on experience is revered
      as a Pranabhisara Vaidya—the true savior of life.
      Embodying these sacred principles, Dr. Jigar Gor is a
      highly qualified and trusted Ayurveda Consultant Doctor
      by profession. Driven by a clinical passion for
      root-cause healing, he has been successfully operating
      his premier wellness center, Dr. Jigar Gor's Ayurveda Center, at Bhuj,
      Kutch, Gujarat, India since 2007. As a pioneer of
      comprehensive holistic healthcare in the Kutch region,
      Dr. Jigar Gor combines ancient wisdom with authentic
      clinical expertise. For nearly two decades, his center
      has been the gold standard for personalized Prakruti
      Parikshan (Body Type Analysis), Nadi Parikshan (Pulse
      Diagnosis), and traditional Panchakarma detox therapies.
      Whether you are seeking natural treatment for chronic
      lifestyle disorders, safe immunity-boosting therapies,
      or long-term wellness solutions, Dr. Jigar Gor provides
      meticulous, compassionate care tailored to restore
      complete harmony to your mind, body, and soul.
    </motion.p>

    <motion.a
      href="/about-us"
      className="primary-btn"
      variants={fadeUp}
      whileHover={{
        scale: 1.04,
      }}
      transition={{
        duration: 0.4,
      }}
    >
      Know More About The Doctor
    </motion.a>
  </motion.div>
</section>

    {/**INSTAGRAM POSTS SECTION */}
  <section className="insta-section">
     <img
    src={greenDesign}
    alt="Check our Instagram | Dr. Jigar Gor's Ayurveda"
    className="insta-design insta-design-top"
  />

  {/* BOTTOM RIGHT DESIGN */}
  <img
    src={greenDesign}
    alt="Check our Instagram | Dr. Jigar Gor's Ayurveda"
    className="insta-design insta-design-bottom"
  />
  <div className="container">
    <motion.p
      className="section-subheading"
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.2,
      }}
      variants={fadeUp}
    >
      Check our Instagram
    </motion.p>

    <motion.h2
      className="section-heading"
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.2,
      }}
      variants={fadeUp}
    >
      Join Our Wellness Community on Instagram
    </motion.h2>

  <motion.div
    className="insta-grid"
    variants={gridContainer}
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.15,
    }}
  >
{instaPosts.map((item, i) => (
  <motion.div
    className="insta-card"
    key={item.id}
    variants={cardVariant}
    whileHover={{ y: -5 }}
    transition={{ duration: 0.4 }}
  >
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      className="insta-link"
    >
      <motion.img
        src={item.img}
        alt={`Instagram Reel ${i + 1} | Dr. Jigar Gor's Ayurveda`}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.6 }}
      />

      <span className="instagram-overlay">
        Click to view Reel
      </span>
    </a>
  </motion.div>
))}
  </motion.div>
<motion.a
      href="https://www.instagram.com/dr.jigargor.ayurveda/"
                target="_blank"
                rel="noopener noreferrer"
      className="primary-btn instagram-btn"
      variants={fadeUp}
      whileHover={{
        scale: 1.04,
      }}
      transition={{
        duration: 0.4,
      }}
    >
      Visit Instagram
      </motion.a>
  </div>
</section>

    {/**FACILITIES SECTION */}
    <Facilities />

    {/**YOUTUBE VIDEOS SECTION */}
    <Youtube />

    {/**TESTIMONIAlS SECTION */}
    <Testimonials />

    {/**BLOGS SECTION */}
   <section className="home-blogs-section container">
  <motion.div
    className="home-blogs-left"
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.2,
    }}
    variants={fadeLeft}
  >
    <p className="section-subheading">
      Insights & Articles
    </p>

    <h2 className="section-heading">
      Timeless secrets for everyday wellness.
    </h2>

    <p className="section-text">
      Where we embark on a journey of discovery into the world
      of Ayurvedic medicine and holistic well-being. In this
      space, we delve into the ancient wisdom of Ayurveda,
      offering valuable insights, practical tips, and
      inspiration to help you cultivate balance, harmony, and
      optimal health in your life. Through our blog, we aim to
      demystify Ayurveda and make its principles accessible to
      all, empowering you to integrate its wisdom into your
      daily life.
    </p>

    <motion.a
      href="/blog"
      className="nav-btn"
      whileHover={{
        scale: 1.04,
      }}
      transition={{
        duration: 0.4,
      }}
    >
      Read all Articles
    </motion.a>
  </motion.div>

  <motion.div
    className="home-blogs-right"
    variants={staggerContainer}
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.15,
    }}
  >
    {blogs.slice(0, 2).map((item, i) => (
      <motion.div
        className="blog-card"
        key={i}
        variants={cardVariant}
        whileHover={{
          y: -5,
        }}
        transition={{
          duration: 0.4,
        }}
      >
        <div
          style={{
            overflow: "hidden",
          }}
        >
          <motion.img
            src={item.img}
            alt={`${item.title} | Dr. Jigar Gor's Ayurveda`}
            whileHover={{
              scale: 1.05,
            }}
            transition={{
              duration: 0.8,
            }}
          />
        </div>

        <div className="blog-card-content">
          <h3 className="card-heading">
            {item.title}
          </h3>

          <p className="section-text">
            {item.intro}
          </p>

          <motion.a
             href={`/blog/${item.slug}`}
            whileHover={{
              x: 6,
            }}
            transition={{
              duration: 0.3,
            }}
          >
            Read Full Article →
          </motion.a>
        </div>
      </motion.div>
    ))}
  </motion.div>
</section>

      <div className="footer-design-wrapper">
    <img
      src={FooterTopDesign}
      alt=""
      className="footer-top-design"
    />
  </div>
        </>
    )
}
export default Home;